module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-ThinItalic.ec4e9c9.woff2";